import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { editCreditEvaluationHubspotDealId as editCreditEvaluationHubspotDealIdAPI } from "api/creditEvaluations";
import { creditEvaluationsKeys } from "api/creditEvaluations/queries";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import HubspotDealIdForm, {
  HubspotDealIdFormValues,
} from "./HubspotDealIdForm";

interface EditHubspotDealIdModalProps {
  isOpen: boolean;
  handleClose: () => void;
  hubspotDealId: string;
  creditEvaluationId: string;
}

const EditHubspotDealIdModal = ({
  isOpen,
  handleClose,
  hubspotDealId,
  creditEvaluationId,
}: EditHubspotDealIdModalProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const queryClient = useQueryClient();

  const { mutateAsync: editCreditEvaluationHubspotDealId, status } =
    useMutation(async (data: { hubspotDealId: string }) => {
      const res = await editCreditEvaluationHubspotDealIdAPI(
        creditEvaluationId,
        data.hubspotDealId,
      );
      await queryClient.invalidateQueries(
        creditEvaluationsKeys.details(creditEvaluationId),
      );
      return res.data;
    });

  const handleSubmit = async (values: HubspotDealIdFormValues) => {
    await editCreditEvaluationHubspotDealId(values, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="Edit HubSpot Deal ID"
        subtitle="Update the HubSpot deal identifier for this credit evaluation."
      />
      <HubspotDealIdForm
        initialValues={{ hubspotDealId }}
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      />
    </AppDialog>
  );
};

export default EditHubspotDealIdModal;
